import C from '../../../constants';

import {browserHistory} from 'react-router';

import PolyUtil from '../../../util/PolyUtil';
import {SubmissionError} from "redux-form";

export const setReference = (reference) => ({
    type: C.SET_REFERENCE,
    payload: reference
});

export const fetchReference = (rental_id, key) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/rental-history/' + rental_id + '/reference/' + key + '/',
        {method: "GET"}
    ).then((data) => {
        return dispatch(setReference(data));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const handleSubmitReference = (data, rental_id, key) => dispatch => {
    return PolyUtil.fetchNoResponse('/api/tenant/application/rental-history/' + rental_id + '/reference/' + key + '/confirm/',
        {method: "POST"}
    ).then(() => {
        return PolyUtil.fetchWrapper('/api/tenant/application/rental-history/' + rental_id + '/reference/' + key + '/',
            {
                method: "PUT",
                body: JSON.stringify(data)
            }
        );
    }).then((data) => {
        browserHistory.push('/confirm/reference/success');
    }).catch((error) => {
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};


// WEBPACK FOOTER //
// ./src/containers/reference/actions/reference.js